import { Box, Skeleton } from "@mui/material";
import React from "react";

function MarkCalledOffSkeleton(): JSX.Element {
  return (
    <Box>
      <Box sx={{ padding: "24px 0px 24px 0px" }}>
        {/* Timing Options */}
        <Box sx={{ marginBottom: "32px", display: "flex", gap: "24px" }}>
          <Skeleton variant='rectangular' width={120} height={40} />
          <Skeleton variant='rectangular' width={120} height={40} />
          <Skeleton variant='rectangular' width={120} height={40} />
        </Box>

        {/* Duration and Time Off Type */}
        <Box sx={{ display: "flex", gap: "24px", marginBottom: "32px" }}>
          <Box sx={{ flex: 1 }}>
            <Skeleton variant='rectangular' width='100%' height={56} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Skeleton variant='rectangular' width='100%' height={56} />
          </Box>
        </Box>

        {/* Reason for Absence */}
        <Box sx={{ marginBottom: "16px" }}>
          <Skeleton variant='rectangular' width='100%' height={80} />
        </Box>
      </Box>
    </Box>
  );
}

export default MarkCalledOffSkeleton;
